import { getAll } from '@/api/person';
const defaultState  = () => {
  return {
    third:{
      id: null,
      name: null,
    },
    list: [],
    loading: false,
    search: null,
    pageSize: 10,
    currentPage: 1,
    totalRows: 0,
  }
}
const third = {
  namespaced: true,
  state: defaultState(),
  getters:{
    all:       state => state.list,
    search:    state => state.search,
    loading:   state => state.loading,
    pageSize:  state => state.pageSize,
    totalRows: state => state.totalRows,
  },
  mutations:{
    RESET_THIRD:(state) => {
      Object.assign(state, defaultState())
    },
    SET_THIRD: (state, connect) => {
      if(connect.prop == 'name'){
        state.third.name = connect.value
      }else{
        state.third = {
          id: connect.value.id,
          name: connect.value.nombre,
        }
      }
    },
    SET_LOADING(state, payload){
      state.loading = payload
    },
    SET_CURRENT_PAGE(state, payload){
      state.currentPage = payload
    },
    SET_SEARCH(state, payload){
      state.search = payload
    },
    SET_LIST(state, payload){
      state.list = []
      state.totalRows = payload.total
      payload.data.forEach((element) => {
        state.list.push({
          id: element.id,
          document: element.documento,
          phone: element.telefono,
          name: element.nombre,
          client: element.cliente,
          seller: element.vendedor,
          provider: element.proveedor,
          used: element.usado,
          file_tax_situation: element.file_tax_situation
        });
      });
    },
  },
  actions:{
    async getAllAction({state, commit}, payload){
      try {
        commit('SET_LOADING', true)
        if (typeof payload == "undefined") {
          if (state.search != null) {
            commit('SET_CURRENT_PAGE', 1)
          }
        } else {
          commit('SET_CURRENT_PAGE', payload)
        }
        let data = await getAll(state.pageSize, state.currentPage, state.search)
        commit('SET_LIST', data.data)
        commit('SET_LOADING', false)
      } catch (error) {
        commit('SET_LOADING', false)
        console.error(error);
        commit('SET_RESPONSE', {type: 'error', msg: 'Error al listar productos.'}, {root: true})
      }
    },
  }
}

export default third